import React from 'react'

const FooterSectionFour = () => {
    return (
        <>
            <h3 className="footer-title">Customer Care</h3>
            <ul className="footer-menu-list">
                <li>
                    <a href="#">My Account</a>
                </li>
                <li>
                    <a href="#">Order History</a>
                </li>
                <li>
                    <a href="#">Wish List</a>
                </li>
                <li>
                    <a href="#">Customer Service</a>
                </li>
                <li>
                    <a href="#">Returns / Exchange</a>
                </li>
                <li>
                    <a href="#">FAQs</a>
                </li>
                <li>
                    <a href="#">Product Support</a>
                </li>
            </ul>
        </>
    )
}

export default FooterSectionFour